const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const StandardStrike = require('../StandardStrike');
const DamageEvent = require('../../events/DamageEvent');
const BleedingCondition = require('../../conditions/BleedingCondition');
const { logError } = require('../../logger');

const Slash = function (battleState) {
  this.handle = 'slash';
  this.physical = true;
  this.weapon = true;
  this.melee = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      var result = this.standardStrike.execute(
        actor,
        victim,
        ability.damage,
        true
      );
      result.abilityHandle = this.handle;

      if (result.success && !victim.dead) {
        // calculate bleed condition potency using a dummy damage event,
        // so we can apply stance adjustments, hero Affinities, etc.
        const bleedDamageDummy = new DamageEvent(
          battleState,
          actor,
          ability.potency,
          this
        );
        bleedDamageDummy.applyStanceAdjustments(victim);
        const bleed_potency = bleedDamageDummy.damage;

        // if the victim already has a bleeding condition with same instigator, add to its potency
        let bleeding = BattleCalc.getCondition(victim, 'bleeding', actor.uid);
        if (bleeding) {
          bleeding.potency += bleed_potency;
          battleState.updateCondition(victim.uid, bleeding.uid);
        } else {
          battleState.onUnitCondition(
            new BleedingCondition(actor, victim, battleState, bleed_potency)
          );
        }
      }

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'Slash',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = Slash;
